import React, {Component, Fragment} from 'react';
import {Button, Card, CardBody, CardTitle, Row} from 'reactstrap';
import {Colxx, Separator} from '../../../../components/common/CustomBootstrap';
import {reactTableText} from '../../../../constants/configs';
import Breadcrumb from '../../../../containers/navs/Breadcrumb';
import ModalManager from '../../../../components/modal/ModalManager';
import PairManageForm from "../../../../containers/PairManageForm";
import {NotificationManager} from '../../../../components/common/react-notifications';
import ReactTableSelectFilter from "../../../../components/ReactTableSelectFilter";
import PairSettings from "../../../../containers/PairSettings";
import {filter, find, keyBy, mapValues, omit} from 'lodash';
import Rbac from '../../../../components/Rbac';
import {withTranslation} from 'react-i18next';
import Api from '../../../../services/Api';
import ReactTable from 'react-table';

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pairs: [],
      allPairs: [],
      loading: true,
      expanded: {},
    };
    this.renderPairFilter = this.renderPairFilter.bind(this);
    this.renderPairNameCell = this.renderPairNameCell.bind(this);
  }

  fetchData = async state => {
    this.setState({loading: true});
    await this.fetchPairs(state);
    this.setState({loading: false});
  };

  fetchPairs = async state => {
    try {
      const {data} = await Api.invoke('GET', '/v2/admin-ui/pairs', undefined, {
        params: {
          ...(state.filtered.length ? omit(mapValues(keyBy(state.filtered, 'id'), 'value'), 'createdAt') : null),
        },
      });
      this.setState({
        pairs: data.pairs,
        ...(!state.filtered.length ? {allPairs: data.pairs} : null),
      });
    } catch (e) {
      console.log('error: ', e);
    }
  };

  deletePair = async name => {
    const {t} = this.props;
    try {
      await Api.invoke('DELETE', `/v2/admin-ui/pairs/${name}`);
      NotificationManager.success(t('Pair {{name}} deleted successfully', {name}), t('Message'));
      this.setState({
        pairs: filter(this.state.pairs, obj => obj.name !== name),
      });
    } catch (e) {
      console.log('error: ', e);
    }
  };

  onPressCreate = () => {
    const {t} = this.props;
    ModalManager.open({
      isOpen: true,
      title: t('Add new pair'),
      body: <PairManageForm afterSubmit={async () => {await this.fetchPairs(this.table.state);}}/>
    });
  };

  onPressEdit = pair => {
    const {t} = this.props;
    ModalManager.open({
      isOpen: true,
      title: t('Edit {{name}} pair', {name: pair.name}),
      body: <PairManageForm pair={pair} afterSubmit={async () => {await this.fetchPairs(this.table.state);}}/>
    });
  };

  onPressDelete = name => {
    const {t} = this.props;
    ModalManager.open({
      isOpen: true,
      title: t('Confirm Delete'),
      body: t('Are you sure you want to delete pair {{name}} ?', {name}),
      buttons: [
        {
          color: 'primary',
          onClick: async () => {
            await this.deletePair(name);
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('Yes'),
        },
        {
          color: 'grey',
          onClick: () => {
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('No'),
        },
      ],
    });
  };

  renderPairNameCell = props => {
    const {name, logoUrl} = props.original;
    return (
      <div className='d-flex flex-row align-items-center'>
        <img
          height={50}
          width={90}
          alt={name}
          className="avatar-mini"
          src={logoUrl || '/assets/img/noimage.jpg'}
        />
        <span className='mx-3 font-weight-semibold text-one'>{name}</span>
      </div>
    );
  };

  getColumns = t => [
    {
      Header: t('Name'),
      accessor: 'name',
      minWidth: 150,
      filterable: true,
      Filter: this.renderPairFilter,
      Cell: this.renderPairNameCell,
    },
    {
      Header: t('English Name'),
      accessor: 'labels',
      Cell: props => <span>{find(props.value, {locale: "en"})?.value}</span>,
    },
    {
      Header: t('Farsi Name'),
      accessor: 'labels',
      Cell: props => <span>{find(props.value, {locale: "fa"})?.value}</span>,
    },
    {
      Header: t('Zones'),
      accessor: 'zones',
    },
    {
      Header: t('Trade Amount Decimals'),
      accessor: 'tradeAmountDecimals',
    },
    {
      Header: t('Price Decimals'),
      accessor: 'priceDecimals',
    },
    {
      Header: t('Status'),
      accessor: 'active',
      Cell: props => {
        return (
          <span className={`font-weight-semibold ${props.value ? 'text-success' : 'text-danger'}`}>
            {props.value ? t('Enabled') : t('Disabled')}
          </span>
        );
      },
    },
    {
      Header: t('Actions'),
      width: 100,
      accessor: 'name',
      Cell: props => <div className='d-flex flex-row align-items-center'>
        <i
          className="simple-icon-pencil edit-icon mr-4 cursor-pointer"
          onClick={() => {this.onPressEdit(props.original);}}
        />
        <i
          className="simple-icon-trash delete-icon cursor-pointer"
          onClick={() => {this.onPressDelete(props.value);}}
        />
      </div>,
    },
  ];

  renderPairFilter({filter, onChange}) {
    const {t} = this.props;
    const options = this.state.allPairs.map(pair => ({
      value: pair.name, label: pair.name,
    }));
    return <ReactTableSelectFilter
      width="50%"
      filter={filter}
      onChange={onChange}
      options={[
        {value: '', label: t('all')},
        ...options,
      ]}
    />;
  }

  onExpanded = (newExpanded, index) => {
    this.setState({
      expanded: {
        ...this.state.expanded,
        [index[0]]: !!newExpanded[index[0]],
      },
    });
  };

  render() {
    const {t} = this.props;
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb match={this.props.match}/>
            <Separator className="mb-5"/>
          </Colxx>
        </Row>
        <Row>
          <Colxx xxs="12" className="mb-4">
            <Card className="h-100">
              <CardBody>
                <CardTitle className="text-large text-primary d-flex flex-row justify-content-between align-items-center">
                  {t('Pairs List')}
                  <Rbac permission='create_admin-users'>
                    <Button onClick={this.onPressCreate}>
                      <i className="simple-icon-plus add-reply-icon"/>
                      <span className="mx-1">{t('Add New Pair')}</span>
                    </Button>
                  </Rbac>
                </CardTitle>
                <ReactTable
                  manual
                  expanded={this.state.expanded}
                  ref={el => {this.table = el;}}
                  onFetchData={this.fetchData}
                  className="-highlight"
                  data={this.state.pairs}
                  loading={this.state.loading}
                  sortable={false}
                  resizable={true}
                  showPagination={false}
                  columns={this.getColumns(t)}
                  onExpandedChange={this.onExpanded}
                  pageSize={this.state.pairs.length || 10}
                  style={{
                    width: '100%'
                  }}
                  {...reactTableText}
                  SubComponent={({original}) => {
                    return (
                      <PairSettings
                        settings={original.setting}
                        pairName={original.name}
                      />
                    );
                  }}
                />
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </Fragment>
    );
  }
}

export default withTranslation()(List);
